import { render } from "./AssignmentStudentsModal.vue?vue&type=template&id=d2a5bd48&scoped=true"
import script from "./AssignmentStudentsModal.vue?vue&type=script&lang=js"
export * from "./AssignmentStudentsModal.vue?vue&type=script&lang=js"

import "./AssignmentStudentsModal.vue?vue&type=style&index=0&id=d2a5bd48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a5bd48"]])

export default __exports__